import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import TextInput from '../../../UI/TextInput'
import moment from 'moment'
import { DEFAULT_PROFILE_PIC_SRC } from './../../../../constants'
import R from 'ramda'

class SetTravelers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      travelers: []
    }
  }

  clearTravelers = () => {
    this.setState(
      {
        travelers: [],
        partySize: 0
      },
      () => this.props.updateState(this.state)
    )
  }

  addTraveler = () => {
    this.setState(
      {
        travelers: [...this.state.travelers, {}]
      },
      () => this.props.updateState(this.state)
    )
  }

  setCouple = () => {
    this.setState(
      {
        travelers: this.state.travelers.length < 1 ? [{}] : [this.state.travelers[0]]
      },
      () => this.props.updateState(this.state)
    )
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.currentState)
  }

  handleFormChange = (index, event) => {
    let travelers = this.state.travelers.slice()
    let name = event.target.name

    if (name === 'age') {
      travelers[index][name] = event.target.value
      travelers[index].yearOfBirth = moment().year() - event.target.value
    } else {
      travelers[index][name] = event.target.value
    }
    this.setState(
      {
        travelers: travelers
      },
      () => this.props.updateState(this.state)
    )
  }

  removeTraveler = (index, event) => {
    let travelers = this.state.travelers.slice()

    this.setState(
      {
        travelers: R.remove(index, 1, travelers)
      },
      () => this.props.updateState(this.state)
    )
  }

  handleGroupNumber = event => {
    let name = event.target.name
    this.setState(
      {
        [name]: parseInt(event.target.value)
      },
      () => this.props.updateState(this.state)
    )
  }

  onChange = event => {
    let name = event.target.name
    this.setState(
      {
        [name]: event.target.value
      },
      () => this.props.updateState(this.state)
    )

    switch (event.target.value) {
      case 'Solo':
        this.clearTravelers()
        break
      case 'Couple':
        this.setCouple()
        break
      case 'Group':
        this.clearTravelers()
        break
      default:
        if (!this.state.travelers.length) {
          this.addTraveler()
        }
        break
    }
  }

  componentWillUnmount() {
    this.props.updateState(this.state)
  }

  render() {
    const { data, t } = this.props
    console.log('state', this.state)
    const imgSrc = data.user && data.user.userProfile.imageAvatar ? data.user.userProfile.imageAvatar.url : DEFAULT_PROFILE_PIC_SRC
    return (
      <form>
        <div className="travellers-info">
          <div className="traveller">
            <img className="traveller__img" src={imgSrc} alt="" />
            <span className="traveller__name">
              {data.user ? data.user.userProfile.firstName + ' ' + data.user.userProfile.lastName : ''}
            </span>
          </div>

          <hr />

          <div className="group-type">
            <h3 className="sub-header">{t('group_type')}</h3>
            <select
              name="travelingType"
              className="form-control group__group-select"
              onChange={this.onChange}
              value={this.state.travelingType}
            >
              <option default selected disabled value="">
                {t('choose')}
              </option>
              <option>{t('family')}</option>
              <option>{t('friends')}</option>
              <option>{t('couple')}</option>
              <option>{t('solo')}</option>
              <option>{t('group')}</option>
              <option>{t('business')}</option>
              <option>{t('other')}</option>
            </select>
          </div>

          {this.state.travelingType &&
            this.state.travelingType !== 'Solo' && (
              <div className="Solo">
                <hr />

                <h3 className="sub-header">{t('travelling_with')}</h3>

                {this.state.travelers.map((partner, index) => (
                  <div style={{ marginBottom: 15 }} className="partner-form-wrapper" key={index}>
                    <div className="partner__input-wrapper">
                      <label htmlFor="fullname">{t('full_name')}</label>
                      <TextInput
                        extraClass="large-input"
                        name="name"
                        initialValue={this.state.travelers[index].name}
                        onBlurExternal={this.handleFormChange.bind(this, index)}
                        id="fullname"
                      />
                    </div>
                    <div className="partner__input-wrapper">
                      <label htmlFor="age">{t('age')}</label>
                      <TextInput
                        extraClass="small-input no-spin"
                        type="number"
                        name="age"
                        initialValue={this.state.travelers[index].age}
                        onBlurExternal={this.handleFormChange.bind(this, index)}
                        maxChars={3}
                        id="age"
                      />
                    </div>
                    {(index > 0 ||
                      ((this.state.travelers[index].name && this.state.travelers[index].name.length > 1) ||
                        (this.state.travelers[index].yearOfBirth && this.state.travelers[index].yearOfBirth.length > 1))) && (
                      <div
                        onClick={this.removeTraveler.bind(this, index)}
                        className="remove-item-link"
                        style={{ float: 'right', marginTop: 45, fontSize: '1.4rem' }}
                      >
                        <span className="icon-cancel" /> {t('main:remove')}
                      </div>
                    )}
                  </div>
                ))}

                {this.state.travelingType &&
                  this.state.travelingType === 'Group' && (
                    <div className="form-group">
                      <label htmlFor="number-people">{t('number_people')}</label>
                      <TextInput
                        extraClass="large-input no-spin"
                        type="number"
                        name="partySize"
                        placeholder="Example: 10-11"
                        initialValue={this.state.partySize ? this.state.partySize : ''}
                        onBlurExternal={this.handleGroupNumber}
                        id="number-people"
                      />
                    </div>
                  )}

                {this.state.travelingType &&
                  this.state.travelingType !== 'Couple' &&
                  this.state.travelingType !== 'Group' && (
                    <div className="add-traveler" onClick={this.addTraveler}>
                      <img className="add-traveler__img" src="/img/plus.svg" alt="" /> {t('add_traveler')}
                    </div>
                  )}
              </div>
            )}
        </div>
      </form>
    )
  }
}

const enhance = compose(translate('booking_steps'))

export default enhance(SetTravelers)



// WEBPACK FOOTER //
// src/components/Guru/BookingSteps/Steps/SetTravelers.jsx